










































































  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import notificationService from '@/services/notificationService';
  import {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
  } from 'devextreme-vue/form';
  import { DxTextArea } from 'devextreme-vue/text-area';

  import { ArticleTypeEnum } from '@/modules/articles/enums/ArticleTypeEnum';
  import { ArticleStatusEnum } from '@/modules/articles/enums/ArticleStatusEnum';
  import { UpdateArticleBasicsCommand, IArticle, ArticlesClient, IArticleCategory, ArticleCategoryClient, MeasuringUnitsClient, MeasuringUnit } from '@/data/web-api-client';
import MyTasksCard from '@/modules/shared/tasks/components/MyTasksCard.vue';

  @Component({
    components: {
      DxForm,
      DxSimpleItem,
      DxGroupItem,
      DxLabel,
      DxTextArea,
    },
  })
  export default class ArticleBasicInfoForm extends Vue {
    @Prop({required: true})
    public value!: IArticle;

    public formdata: IArticle = {
      id: '',
      name: '',
      status: undefined,
      measuringUnit: '',
      allowedWorktypes: [],
      description: '',
      type: undefined,
      categoryId: undefined
    };

    private saving: boolean = false;
    private initialised: boolean = false;
    private articleCategories: IArticleCategory[] = [];

    public async mounted() {
     await this.getArticleCategories();
      this.setValues();
    }

    private async getArticleCategories() {
      this.articleCategories = await new ArticleCategoryClient(undefined, this.$axios).get();
    }

    private setValues() {
      this.initialised = false;

      this.formdata.id = this.value.id ? this.value.id : '';
      this.formdata.name = this.value.name;
      this.formdata.measuringUnit = this.value.measuringUnit;
      this.formdata.allowedWorktypes = this.value.allowedWorktypes;
      this.formdata.description = this.value.description;
      this.formdata.status = this.value.status;
      this.formdata.type = this.value.type;
      this.formdata.categoryId = this.value.categoryId;

      setTimeout(() => {
        this.initialised = true;
      }, 100);
    }

    public async change(e: any) {
      if (!this.initialised) {
        return;
      }

      try {
        this.saving = true;

        const command = new UpdateArticleBasicsCommand({
          id: this.formdata.id,
          name: this.formdata.name,
          status: this.formdata.status,
          measuringUnit: this.formdata.measuringUnit,
          allowedWorktypes: this.formdata.allowedWorktypes,
          description: this.formdata.description,
          categoryId: this.formdata.categoryId
        });
        const result = await new ArticlesClient(undefined, this.$axios).updateBasicInfo(this.formdata.id!, command);

        this.$emit('input', result);
        notificationService.saved();
      } catch (err) {
        notificationService.showAxiosError(err);
      } finally {
        this.saving = false;
      }
    }

    get articleStatusOptions() {
      const items = [
        {value: ArticleStatusEnum.Active, text: 'Actief'},
        {value: ArticleStatusEnum.Disabled, text: 'Inactief'},
      ];

      return { items, displayExpr: 'text', valueExpr: 'value' };
    }

    get articleTypesOptions() {
      const items = [
        {value: ArticleTypeEnum.Default, text: 'Basis'},
        {value: ArticleTypeEnum.Combiniation, text: 'Combinatie'},
      ];

      return { items, displayExpr: 'text', valueExpr: 'value', disabled: true };
    }

    get measuringunitOptions() {
      const items = this.$store.getters['measuringUnits/data'];

      return { items };
    }

    get worktypesOptions() {
      const catalog = this.$store.getters['catalogs/list']('WorkTypes');
      const items = catalog ? catalog.values : [];
      return { items };
    }

    get articleCategoryOptions() {
      const items = this.articleCategories.map(ac => ({
        value: ac.id,
        text: ac.name
      }));

      return {
        dataSource: items,
        displayExpr: 'text',
        valueExpr: 'value',
        filterExpr: 'value'
      };
    }

    @Watch('value', {deep : true})
    private onPropertyChanged(value: any, oldValue: any) {
      this.setValues();
    }
  }
